import "components/template_journal/template_journal";
import "components/journal_post/journal_post";
import "components/journal_posts/journal_posts";
import "components/journal_sub_nav/journal_sub_nav";
import "components/pagination/pagination";
import "components/featured_post/featured_post";
import "components/latest_posts/latest_posts";
import "components/popular_topics/popular_topics";